import User from './UserNewController';

export default User;
